import { inject, Service } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ToastService } from '@app/core/services/toast.service';
import { PollDto } from '@app/_api/dto';
import { DialogConfig, DialogService } from '@app/core/services/dialog.service';
import { PollDialogModel } from '@app/_api/model';
import { PollOverlayDialogComponent } from '@app/features/poll-overlay-dialog/poll-overlay-dialog';
import { BaseApi } from '@app/core/services/api/base.api';

@Service()
export class PollService extends BaseApi {
  constructor() {
    const http = inject(HttpClient);
    const toastService = inject(ToastService);
    const dialog = inject(DialogService);

    super(http, '/poll', toastService, dialog);
  }

  getAllPolls(): Observable<PollDto[]> {
    return super.GET<PollDto[]>('/all');
  }

  createPoll(createPollDto: PollDto) {
    return super.POST<PollDto>('/add', createPollDto, {
      success: 'Umfrage erfolgreich angelegt',
      error: 'Fehler beim Anlegen der Umfrage',
    });
  }

  updatePoll(poll: PollDto) {
    return super.POST<PollDto>(`/update/${poll.uuid}`, poll, {
      success: 'Umfrage erfolgreich geändert',
      error: 'Fehler beim Aktualisieren der Umfrage',
    });
  }

  setActive(poll: PollDto) {
    return super.POST<PollDto[]>(
      `/activate/${poll.uuid}`,
      {},
      {
        success: 'Umfrage erfolgreich aktiviert',
        error: 'Fehler beim Aktualisieren der Umfrage',
      },
    );
  }

  deletePoll(uuid: string): Observable<PollDto> {
    return super.DELETE<PollDto>(`/${uuid}`, undefined, {
      success: 'Umfrage erfolgreich gelöscht',
      error: 'Fehler beim Löschen der Umfrage',
    });
  }

  getActive(isFrequencyRelevant: boolean): Observable<PollDto> {
    return super.GET<PollDto>(`/get/${isFrequencyRelevant}`);
  }

  viewed(uuid: string): Observable<PollDto> {
    return super.PUT<PollDto>(`/viewed/${uuid}`);
  }

  feedbackDialog(isFrequencyRelevant: boolean) {
    this.getActive(isFrequencyRelevant).subscribe(poll => {
      if (poll || !isFrequencyRelevant) {
        const dialogConfig: DialogConfig = {
          data: {
            poll,
          } as PollDialogModel,
        };
        this.dialogService
          .open(PollOverlayDialogComponent, dialogConfig)
          .afterClosed()
          .subscribe(() => {
            if (poll) {
              this.viewed(poll.uuid).subscribe();
            }
          });
      }
    });
  }
}
